import styled from 'styled-components'

export const BreakdownButtonContainer = styled.span`
  margin-right: 8px;
  font-size: 12px;
  font-weight: 400;
`

export const ProfitSummaryContainer = styled.div`
  padding: 0 20px;
`
